import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Check } from 'lucide-react';

interface Stage06DialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedOpportunity: any;
  onAccept: () => void;
  onDecline: () => void;
}

export function Stage06Dialog({
  isOpen,
  onOpenChange,
  selectedOpportunity,
  onAccept,
  onDecline
}: Stage06DialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="glass-dialog max-w-md">
        <DialogHeader>
          <DialogTitle>Accept Quote?</DialogTitle>
          <DialogDescription>
            Do you want to accept this quote and move it to Closed Won?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Opportunity Details */}
          <div className="glass-card p-4 space-y-2">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-medium">{selectedOpportunity?.end_user.name}</p>
                <p className="text-sm text-muted-foreground">{selectedOpportunity?.opportunity_id}</p>
              </div>
              <Badge variant="outline" className="glass-badge">
                {selectedOpportunity?.opportunity_value}
              </Badge>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button
            variant="outline"
            onClick={onDecline}
          >
            Cancel
          </Button>
          <Button
            onClick={onAccept}
            className="bg-worldsview-green hover:bg-worldsview-green/90"
          >
            <Check className="w-4 h-4 mr-2" />
            Yes, Accept
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
